/*
 interface SearchObject {
 baseBulkSize: number;
 nextBulkSize: number;

 query: string;
 facets: any[];
 pcAvailability: boolean;
 scope: any;
 sortBy: string;


 searchInProgress: boolean;
 }

 interface SearchStateService{
 currentItem: any;
 resultObject: any;
 searchObject: any;
 selectedItem: any;
 getItemAtIndex: any;
 hasNextBulk: any;
 isNotFirstBulk: any;
 nextBulk: any;
 previousBulk: any;
 getResultObject: any;
 getSearchObject: any;
 setSearchObject: any;
 setResultObject: any;
 updateSearchObject: any;
 selectItem: any;
 getSelectedItem: any;
 addImagesToResultObject: any;
 isSearchInProgress: any;
 setSearchInProgress: any;
 selectedDetail?: any;
 }
 */

import { getDefaultScope } from '../appConfig/appConfigForward';
import { getResultsBulkSize, getShowMoreThreshold } from '../appConfig/appConfigForward';

import { Injectable, Inject } from 'ng-metadata/core';
import { JsonUtils } from '../nddUtils/jsonUtils.service';
import IPromise = angular.IPromise;
import {PrimoResponse} from '../infra/dataStructures/PrimoResponses/doc.interfcae';

const angular: angular.IAngularStatic = require('angular');
interface IFacet {
	displayedType: string;
	facetType: string;
	label: string;
	name: string;
	type: string;
	isMultiFacet: boolean;
    multiFacetGroupId: string;
    checked: boolean;
	value: string;
	tooltip: string;
    translationsPromise: IPromise<IFacet>;
}

export interface ISearchObject {
	noConVoc?: boolean;
	newSearch: boolean;
	offset: number;
	to: number;
	bulkSize: number;
	facets: IFacet[];
	mode: string;
	pcAvailability: boolean;
	query: string;
	scope: string;
	browseParams: string;
	searchInProgress: boolean;
	skipDelivery: string;
	sortby: string;
	explain: string;
    searchCDI: string;
	tab: string;
	journals: string;
	databases: string;
	featuredNewspapersIssnList: string;
	fromDate: string;
	getMore: number;
	metalibMoreStatus: {};
	isRelatedItems: false;
	organization: string

}

interface IResultInfoObject {
	total: number;
	last?: string;
	maxTotal?: number;
    errorDetails?: string;
}

class ResultObject {
	public info: IResultInfoObject;
	public data = [];



	private featuredResult : {};
	private didUMean: string;
	private details: {};
	public facets: {};
	private images: {};
	public beaconO22: {}; // server response time

	public lang3: string;

	public saveResponse(res) {
		this.featuredResult = res.featuredResult;
		this.data = res.groups;
		this.didUMean = res.did_u_mean;
		this.details = res.details;
		this.info = res.info;
		this.facets = res.facetsList;
		this.images = res.images;
		this.beaconO22 = res.beaconO22;
		this.lang3 = res.lang3;
	}
	public updateResponse(res, replaceResults = false) {
		if (replaceResults) {
			this.data = res.groups;
		}
		else {
			Array.prototype.push.apply(this.data, res.groups);
		}

		this.info = res.info;
		this.facets = res.facetsList;
		this.beaconO22 = res.beaconO22;
	}
	public updateResponseImages(images) {

		this.images = images;
	}

}



@Injectable()
export class SearchStateService {
	private resultsBulkSize = getResultsBulkSize();
	private showMoreThreshold = getShowMoreThreshold();

	/* private members */
	private currentItem: Object;
	private resultObject: ResultObject = new ResultObject();
	private searchObject: ISearchObject;
	private selectedItem: Object;
    private tempTopMaxItems: PrimoResponse.IDoc[] = [];

	private firstBulk = 0;
	private selectedDetail;
    private PAGE_SIZE;

	constructor(private jsonUtils: JsonUtils,
		@Inject('$filter') private $filter: ng.IFilterService,
		@Inject('$anchorScroll') private $anchorScroll: ng.IAnchorScrollService) {
		this.$filter = $filter;

		/* private members */
		this.currentItem = {};
		this.selectedItem = '';
		this.PAGE_SIZE = getResultsBulkSize();
	}

	resetResultObject() {
		this.resultObject = new ResultObject();
	}

	public resetSearchObject() {
		this.searchObject = {} as ISearchObject;
	}

	public getItemAtIndex(index) {
		let data = this.resultObject.data;
		if (data && data.length > index) {
			return data[index];
		}
		else {
			return null;
		}
	}
	public hasNextBulk() {
		let total = (this.resultObject.info.maxTotal && this.resultObject.info.maxTotal > 0) ?
			this.resultObject.info.maxTotal :
			this.resultObject.info.total;
		return this.resultObject.info && (this.searchObject.to < total);
	}

	public isNotFirstBulk() {
		return this.searchObject.offset > this.firstBulk;
	}

	public nextBulk() {
		//Change 'offset' to current offset plus bulk size
		//e.g. if bulk size is 5 and offset is 20, list is up to 20 + 5 = 25, so we want to get records offset 25
		//notice that in case of the rest records is less than the bulk size, the right amount of records will be gotten
		//e.g. offset is 20, bulk size is 5 but the list size is only 23, only 3 records will be gotten
		this.searchObject.offset = Math.min(
			this.searchObject.offset + this.searchObject.bulkSize, this.resultObject.info.total);
		//Update 'to'
		//This field is only for calculate the has next bulk and not used in the query
		this.searchObject.to = Math.min(
			this.searchObject.offset + this.searchObject.bulkSize, this.resultObject.info.total);
	}

	public jumpToPage(page) {
		this.searchObject.offset = Math.min(
			page * 10, this.resultObject.info.total);
		//On next bulk, change the bulk size (reduce it)
		//Update 'to'
		//This field is only for calculate the has next bulk and not used in the query
		this.searchObject.to = Math.min(
			this.searchObject.offset + this.searchObject.bulkSize, this.resultObject.info.total);
		this.searchObject.newSearch = true;
	}

	public previousBulk() {
		this.searchObject.offset = Math.max(this.searchObject.offset - this.searchObject.bulkSize, 1);
		let to = this.searchObject.offset + this.searchObject.bulkSize - 1;
		this.searchObject.to = Math.min(to, this.resultObject.info.total);
	}

	public getResultObject() {
		return this.resultObject;
	}

	public get numOfLoadedResultBulks(): number {
		if (!this.resultObject || !this.resultObject.data) {
			return 0;
		}
		return Math.ceil(this.resultObject.data.length / this.PAGE_SIZE);
	}

	public getSearchObject(): ISearchObject {
		//removing the || {} caused issue PRM-33119
		return this.searchObject || ({} as ISearchObject);
	}

	public setUpdatedSearchObject(args) {
		this.searchObject = {
			bulkSize: this.resultsBulkSize,
			query: args.query || this.searchObject.query,
			facets: args.facets || this.searchObject.facets,
			pcAvailability: args.pcAvailability || this.searchObject.pcAvailability,
			scope: args.scope || this.searchObject.scope,
			browseParams: this.searchObject.browseParams,
			tab: args.tab || this.searchObject.tab,
			explain: args.explain || this.searchObject.explain,
            searchCDI: args.searchCDI || this.searchObject.searchCDI,
			sortby: args.sortby || this.searchObject.sortby,
			journals: args.journals || this.searchObject.journals,
			databases: args.databases || this.searchObject.databases,
            featuredNewspapersIssnList: args.featuredNewspapersIssnList || this.searchObject.featuredNewspapersIssnList,
			fromDate: args.fromDate || this.searchObject.fromDate,
			offset: this.firstBulk,
			to: this.resultsBulkSize,
			newSearch: true,
			searchInProgress: false,
			mode: this.searchObject.mode,
			getMore: args.getMore,
			isRelatedItems: args.isRelatedItems
		};
	}

	public setSearchObject(args) {
		if (args.searchObject) { //TODO
			args = args.searchObject;
		}

		let offset = args.offset || this.firstBulk;

		this.searchObject = {
			bulkSize: getResultsBulkSize(),
			query: args.query || '',
			facets: args.facets || [],
			pcAvailability: args.pcAvailability || false,
			scope: args.scope || getDefaultScope(),
			browseParams: args.browseParams,
			tab: args.tab,
			journals: args.journals,
			databases: args.databases,
			featuredNewspapersIssnList : args.featuredNewspapersIssnList,
			fromDate: args.fromDate,
			sortby: args.sortby,
			explain: args.explain,
            searchCDI: args.searchCDI,
			offset: offset,
			to: offset + this.resultsBulkSize,
			newSearch: true,
			searchInProgress: false,
			mode: args.mode,
			getMore: args.getMore,
			isRelatedItems: args.isRelatedItems,
			organization: args.organization
		};
		if(args['noConVoc']) {
			this.searchObject.noConVoc = true;
		}
	}

	public setResultObject(searchResponse, replaceResults = false) {

		if (this.searchObject.newSearch) {
			this.searchObject.newSearch = false;
			this.$anchorScroll();
			this.resultObject.saveResponse(searchResponse);
		} else {
			if (replaceResults) {
				this.$anchorScroll();
			}
			this.resultObject.updateResponse(searchResponse, replaceResults);

		}

	}
	
    public setTempResultList( tempRes ) {
        this.tempTopMaxItems = tempRes;
    }
    
    public getTempResultList(){
        return this.tempTopMaxItems;
    }

	public updateSearchObject(args) {
		angular.extend(this.searchObject, args);
	}
	public updateResultObject(args) {
		angular.extend(this.resultObject, args);
	}

	public selectItem(item) {
		this.selectedDetail = item;
	}

	public getSelectedItem() {
		return this.selectedDetail;
	}

	public addImagesToResultObject(searchResponse) {

		let imagesBarFillers = [];
		if (!angular.isUndefined(searchResponse.images)) {

			let imagesBarFillersArray = this.jsonUtils.convertObjectToArray(searchResponse.images);
			imagesBarFillersArray = this.$filter('filter')(imagesBarFillersArray, '!img/icon_image.png');
			for (let i = 0; i < imagesBarFillersArray.length && i < 9; i++) {
				imagesBarFillers.push({ link: imagesBarFillersArray[i], type: 'dynamic' });
				//                    imagesBarFillers[i].link = imagesBarFillersArray[i];
				//                    imagesBarFillers[i].type = 'dynamic';
			}

			imagesBarFillers = imagesBarFillers.sort(function () {
				return 5 - Math.random();
			});
		}
		this.resultObject.updateResponseImages(imagesBarFillers);

	}

	public isSearchInProgress() {
		return (this.searchObject && this.searchObject.searchInProgress) || false;
	}

	public setSearchInProgress(value) {
		this.searchObject.searchInProgress = value;
	}

	public setSkipDelivery(value) {
		this.searchObject.skipDelivery = value;
	}

	public getSkipDelivery() {
		return this.searchObject.skipDelivery;
	}


}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchState.service.ts